export const GENERIC_PDF_ERROR = "Couldn't prepare the signed document. Please try again.";
const TYPED_CHARACTER = "Couldn't add your entries to the document. Remove any special characters and try again.";
const LOCKED_CHARACTER = "Your details on file include a character the document can't print. Contact support to update them.";

// pdf-lib's standard fonts throw 'WinAnsi cannot encode "X" (0x…)' for characters outside WinAnsi; other failures get the
// generic message. When X comes from a value on file the signer can't edit, only support can fix it.
export const pdfBuildErrorMessage = (error, lockedValues = []) => {
  const message = String(error?.message ?? "");
  if (!/cannot encode/i.test(message)) return GENERIC_PDF_ERROR;
  // pdf-lib quotes the character through String.fromCharCode, which truncates emoji; its hex code is exact.
  const found = /cannot encode "(.*?)"(?: \((0x[0-9a-f]+)\))?/i.exec(message);
  const character = found?.[2] ? String.fromCodePoint(parseInt(found[2], 16)) : found?.[1];
  if (character && lockedValues.some((value) => String(value ?? "").includes(character))) {
    return LOCKED_CHARACTER;
  }
  return TYPED_CHARACTER;
};

// ENG-1865: a character the signer typed is the one build failure they can fix; sign-all holds an agreement for any other.
export const signerCanFixPdfError = (error, lockedValues = []) => pdfBuildErrorMessage(error, lockedValues) === TYPED_CHARACTER;

// ENG-1865: a value on file the font can't print fails every build of that agreement, so sign-all holds it at its preview.
export const lockedValueCantPrint = (error, lockedValues = []) => pdfBuildErrorMessage(error, lockedValues) === LOCKED_CHARACTER;

// The values the page prints from records, which the signer can't change: the CP pages' locked fields, and everything
// the plain /operator-sign page stamps (its inputs are all disabled; its date is plain ASCII).
export const lockedStampValues = ({ isCpPage, cpFields, recordValues }) =>
  isCpPage ? cpFields.filter((entry) => entry.locked).map((entry) => entry.value) : recordValues;
